/**
 * Holds the short-lived (~10 min) enrolment token handed out by `/auth/login`
 * when `mustEnrollTwoFactor` is true.
 *
 * Deliberately a module-level value, not `secureStorage`: the BE contract calls
 * this a throwaway step-up credential and requires it stay in memory. It is not
 * an access token and is rejected by the `Authorization` header.
 *
 * Consequence: a hard refresh mid-setup drops it and MfaSetup bounces to
 * `/login`. That is the intended behaviour — the user re-authenticates and the
 * BE issues a fresh token.
 */
let enrolmentToken: string | null = null

export const setEnrolmentToken = (token: string): void => {
  enrolmentToken = token
}

export const getEnrolmentToken = (): string | null => enrolmentToken

export const clearEnrolmentToken = (): void => {
  enrolmentToken = null
}
